import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { AttendeeUser } from '@/types/all-attendees.types';

export const setAllAttendeesUsers = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<AttendeeUser[]>((state, action) => {
    state.allAttendees.users = action.payload;
    state.allAttendees.loading = false;
  });
